import { RenderInputByTypeMobile } from "./RenderInputByTypeMobile";
import { Grid } from '@mui/material';
import '../../Pages/ContratosCreation/components/TabDatosPrincipales/tabDatosPrincipales.scss';

export const RenderInputsRowByType = ({
	input,
	handleChange,
	value,
	isRowWithTitle
}) => {

	return (
		isRowWithTitle ? <Grid size={{ xs: 100, sm: 50, md: 50, lg: input.col }}>
			<div
				className={"input"}
			>
				<RenderInputByTypeMobile
					handleChange={handleChange}
					input={input}
					value={value}
				/>
			</div>
		</Grid>
			:
			<Grid size={{ xs: 100, sm: 50, md: 50, lg: input.col }}>
				<RenderInputByTypeMobile
					handleChange={handleChange}
					input={input}
					value={value}
				/>
			</Grid>
	);
}